<template>
  <fullscreen-modal :visible.sync="visible" :title="'查看评价'" :close-on-click-modal="false" @close="handleClose">
    <div class="view-evaluation-modal">
      <el-form ref="evaluationForm" label-width="120px">
        <el-card shadow="hover" class="card">
          <div slot="header" class="clearfix">
            <span>评价信息:</span>
          </div>
          <!-- <div class="fixed-cards" v-if="evaluationInfo && Object.keys(evaluationInfo).length > 0">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="评价人:">
                  <span>{{ evaluationInfo.evaluatorName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="评价时间:">
                  <span>{{ evaluationInfo.evaluateTime ? new Date(evaluationInfo.evaluateTime).toLocaleString() : '-'
                  }}</span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="总体评分:">
                  <span>{{ evaluationInfo.overallScore }}分</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="评价状态:">
                  <span>{{ evaluationInfo.status }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div> -->

          <div class="fixed-cards" v-if="dynamicColumns.length > 0">
            <el-card shadow="hover" class="card">
              <div slot="header" class="clearfix">
                <span>评价详情:</span>
              </div>
              <div class="card-content">
                <el-row>
                  <el-col v-for="column in dynamicColumns" :key="column.id"
                    style="display: flex;align-items: center;text-align: center;"
                    :span="getSpan(dynamicColumns.length)">
                    <strong>{{ column.fieldName }}:</strong>
                    <span v-if="['input', 'checkbox', 'radio'].includes(column.inputType)">{{
                      column.fieldValue }}</span>
                    <!-- 评分星级 -->
                    <span v-else-if="column.inputType === 'star'"
                      style="display: flex;align-items: center;text-align: center;">
                      <el-rate v-model="column.fieldValue" disabled></el-rate>
                      <span>{{ column.fieldValue == '1' ? '差' : column.fieldValue == '2' ? '一般' :
                        column.fieldValue == '3' ? '好' : column.fieldValue == '4' ? '很好' :
                          column.fieldValue
                            == '5' ? '非常好' : '' }}</span>
                    </span>
                    <span v-else><time>{{ column.fieldValue }}</time></span>
                  </el-col>
                </el-row>
                <el-row v-if="dynamicColumns.length === 0">
                  <el-col :span="24">
                    <p>暂无数据</p>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </div>

          <div class="dynamic-cards" v-if="imageFields.length > 0">
            <el-card shadow="hover" class="card">
              <div slot="header" class="clearfix">
                <span>评价图片:</span>
              </div>
              <div class="form-row" v-for="column in imageFields" :key="column.id">
                <p class="gap-line-border" v-if="column.inputType === 'img'">
                  <span class="nameStyle">{{ column.fieldName }}:</span>
                  <span class="gap-line"></span>
                  <span v-if="column.fieldValue">
                    <viewer :images="formmaterImage(column.fieldValue)">
                      <img v-for="src in formmaterImage(column.fieldValue)" :src="src" :key="src" class="card-image" />
                    </viewer>
                  </span>
                  <span v-else>暂无图片</span>
                </p>
              </div>
            </el-card>
          </div>

          <el-row>
            <div class="btn-group">
              <el-button type="danger" size="small" @click="handleClose"
                icon="el-icon-circle-close-outline">关闭</el-button>
            </div>
          </el-row>
        </el-card>
      </el-form>
    </div>
  </fullscreen-modal>
</template>

<script>
import { evaluateInfoView } from "@/api/salesCloud/preFilter";
import { findDataSourceFields } from "@/api/work/dynamicForm";
import FullscreenModal from "./fullscreen-modal.vue";

export default {
  name: "ViewEvaluationModal",
  components: {
    FullscreenModal,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      evaluationInfo: {},
      dynamicColumns: [],
      imageFields: [],
      inputTypes: [],
    };
  },
  watch: {
    visible(val) {
      if (val && this.id) {
        this.loadEvaluationData();
      }
    },
  },
  methods: {
    loadEvaluationData() {
      this.resetData();
      this.getEvaluationData();
    },
    resetData() {
      this.evaluationInfo = {};
      this.dynamicColumns = [];
      this.imageFields = [];
      this.inputTypes = [];
    },
    getEvaluationData() {
      // 获取动态控件类型
      findDataSourceFields().then(res => {
        let data = JSON.parse(res.data);
        this.inputTypes = data;
        // 获取评价数据
        const params = {
          id: this.id,
          code: 'PIPELINE_EVALUATION'
        };
        evaluateInfoView(params).then(res => {
          if (res.code == "200") {
            const jsonData = JSON.parse(res.data); // 解析返回的 JSON 数据

            // 设置评价基本信息
            this.evaluationInfo = {
              evaluatorName: jsonData.evaluatorName || '',
              evaluateTime: jsonData.evaluateTime || null,
              overallScore: jsonData.overallScore || 0,
              status: jsonData.status || '',
              content: jsonData.content || ''
            };

            // 将图片字段单独处理
            const imageFields = jsonData.list.filter(item => item.inputType == '8').map(item => ({
              id: item.id,
              fieldName: item.fieldName,
              inputType: this.getInputType(item.inputType), // 获取输入类型
              fieldValue: item.value
            }));
            this.imageFields = imageFields;

            // 其他字段
            const dynamicColumns = jsonData.list.filter(item => item.inputType != '8').map(item => ({
              id: item.id,
              fieldName: item.fieldName,
              inputType: this.getInputType(item.inputType), // 获取输入类型
              fieldValue: item.dataType.word == 'star' ? parseInt(item.value) : item.value
            }));
            /* // 计算评价总分，通过遍历item.dataType.word == 'star'的fieldValue，将其转换为整数后累加
            let totalScore = 0;
            dynamicColumns.forEach(item => {
              if (item.inputType == 'star') {
                totalScore += parseInt(item.fieldValue);
              }
            });
            this.evaluationInfo.overallScore = totalScore; */

            this.dynamicColumns = dynamicColumns;
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
          }
        }).catch(err => {
          this.$message.error('获取评价数据失败');
        });
      }).catch(err => {
        this.$message.error('获取动态控件类型失败');
      });
    },
    getSpan(length) {
      // 动态计算每列的span值
      return Math.floor(24 / Math.min(length, 3)); // 最多3列
    },
    formmaterImage(row) {
      let str = new Array();
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          str.push(picArray[i]);
        }
      }
      return str;
    },
    getInputType(inputType) {
      const item = this.inputTypes.find(type => type.id == inputType);
      return item ? item.word : ''; // 返回输入类型的名称
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.view-evaluation-modal {
  min-height: 100%;
}

.card {
  margin-bottom: 20px;
}

.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-group {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 10px;
}
</style>